<div class="subscription-form-container">

  <div class="header-form">
    <div class="title">Formulaire de souscription</div>
    <button class="back" (click)="back()">Annuler</button>
  </div>

  <ng-container *ngIf="definition; else noDefinitionTemplate">
    <div class="form" *ngIf="definition" [formGroup]="form">
      <div class="mandatory-fields-forms">
        <div class="article">
          <div class="name">
            <strong>Article associé : </strong> <span>{{ articleName }}</span>
          </div>
          <div class="free-place" *ngIf="article?.placeFree">
            <strong>Places disponibles : </strong> <span>{{ article.placeFree }}</span>
          </div>
        </div>
        <div class="username">
          <mat-form-field appearance="outline" class="fname">
            <mat-label>Prénom</mat-label>
            <input id="" matInput formControlName="firstName" required />
          </mat-form-field>
          <mat-form-field appearance="outline" class="lname">
            <mat-label>Nom</mat-label>
            <input id="" matInput formControlName="lastName" required />
          </mat-form-field>
        </div>

        <div class="contact">
          <mat-form-field appearance="outline" class="email">
            <mat-label>Email</mat-label>
            <input type="email" id="" matInput formControlName="email" required />
          </mat-form-field>
          <mat-form-field appearance="outline" class="phone">
            <mat-label>N° de téléphone</mat-label>
            <input type="string" id="" matInput formControlName="phone" required />
          </mat-form-field>
        </div>

        <div class="info">
          <mat-form-field appearance="outline" class="city">
            <mat-label>Ville</mat-label>
            <input id="" matInput formControlName="city" required />
          </mat-form-field>
          <mat-form-field appearance="outline" class="participantCount">
            <mat-label>Nombre de participants</mat-label>
            <input type="number" id="" matInput formControlName="participantCount" required />
          </mat-form-field>
        </div>

        <app-field-group
          view="fill" class="custom-fields"
          [fields]="definition.fields"
          (fieldsChange)="onFieldsChange($event)">
        </app-field-group>

      </div>

    </div>
  </ng-container>

  <ng-template #noDefinitionTemplate>
    <div class="no-definition">
      <mat-spinner diameter="100"></mat-spinner>
    </div>
  </ng-template>

  <div class="actions">

    <ng-container *ngIf="!isLoading; else loadingTemplate">
      <button mat-raised-button class="cancel" (click)="back()">Annuler</button>
      <button mat-raised-button class="save" (click)="save()"
        [disabled]="form.invalid || !canCustomFieldsSubmit"
        >
        {{ subscriptionKey ? 'Modifier' : 'Ajouter' }}
      </button>
    </ng-container>

    <ng-template #loadingTemplate>
      <mat-spinner diameter="50"></mat-spinner>
    </ng-template>

  </div>

</div>
